import { cn } from '@/lib/cn';

/**
 * The Tabashir mark: the letter ت as a smile (bowl and two dots, one amber)
 * on the green tile. Same geometry as public/favicon.svg and docs/brand.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 100 100" aria-hidden className={cn('shrink-0', className)}>
      <rect width="100" height="100" rx="26" fill="#176a4e" />
      <g transform="translate(16 16) scale(.68)">
        <path d="M18 46Q18 80 50 80Q82 80 82 46" fill="none" stroke="#fff" strokeWidth="12" strokeLinecap="round" />
        <circle cx="38" cy="26" r="8" fill="#fff" />
        <circle cx="62" cy="26" r="8" fill="#fab45f" />
      </g>
    </svg>
  );
}
